import { StyleRules } from "@material-ui/core";
import { BACKGROUND_COLOR, WHITE, NEUTRAL_GREY } from "constants/colors";

export const styles: StyleRules = {
  root: {
    backgroundColor: BACKGROUND_COLOR,
    width: "100%",
    padding: "10px 0px",
    margin: "0",
  },
  logoContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingLeft: "20px",
  },
  logo: {
    maxWidth: "105px",
    width: "90px",
  },
  containerLogOut: {
    cursor: "pointer",
    textAlign: "right",
  },
  iconLogoLogOut: {
    height: "16px",
    width: "16px",
    display: "inline-block",
    top: "2px",
    position: "relative",
  },
  logOutText: {
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "1.2",
    letterSpacing: "0.2px",
    color: WHITE,
    marginLeft: "5px",
    display: "inline-block",
  },
  headerTextMessage: {
    fontSize: "14px",
    LineHeight: "16.41px",
    fontWeight: "normal",
    fontStretch: "normal",
    paddingTop: "20px",
    fontStyle: "normal",
    paddingLeft: "0px !important",
    letterSpacing: "normal",
    color: "#C6D1E0",
    margin: "0px",
    fontFamily: "Roboto",
    width: "391px",
    height: "32px",
    left: "998px",
    top: "365px",
  },
};
